import { AppProgressProvider, useRouter } from "./chunk-IABMTV44.js";
import "./chunk-G56CNV7G.js";
export { AppProgressProvider as ProgressProvider, useRouter };
//# sourceMappingURL=app.js.map